<template>
  <div class="founders-base bg-bg">
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    board: {
      type: [Boolean,String, Object],
      default: false,
    },
  },
  data: function () {
    return {
      isActive: false,
      modifiedCssVariables: [],
      originalCssVariables: {},
      defaultColorScheme: {
        lead: "#3867d6",
        "core-lead": "#3867d6",
        success: "#07a652",
      },
    };
  },
  computed: {},
  watch: {
    board: {
      handler(newVal) {
        if (newVal) {
          this.overrideDomVariables(newVal);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    if (utilities.isSSR()) {
      // probably not required, but lets be safe
      return;
    }
    this.overrideDomVariables();
  },
  activated() {
    this.overrideDomVariables();
  },
  beforeUnmount() {
    this.restoreDomVariables();
  },
  methods: {
    async overrideDomVariables(board) {
      if (utilities.isSSR()) {
        return true;
      }
      if (!board) {
        board = this.board;
      }

      if (!board) {
        return true;
      }

      this.getRootCssVariables().forEach((rawName) => {
        let cleanName = rawName.replace("--", "");
        let currentDomValue = window
          .getComputedStyle(document.documentElement)
          .getPropertyValue(rawName);

        if (!this.originalCssVariables[rawName]) {
          this.originalCssVariables[rawName] = currentDomValue;
        }

        if (
          this.board &&
          this.board.themeSettings &&
          this.board.themeSettings[cleanName]
        ) {
          document.documentElement.style.setProperty(
            rawName,
            this.board.themeSettings[cleanName]
          );

          if (!this.modifiedCssVariables.includes(rawName)) {
            this.modifiedCssVariables.push(rawName);
          }
        }
      });
    },
    restoreDomVariables() {
      if (utilities.isSSR()) {
        return true;
      }
      this.getRootCssVariables().forEach((rawName) => {
        if (!this.originalCssVariables[rawName]) {
          return true;
        }
        if (!this.modifiedCssVariables.includes(rawName)) {
          return true;
        }
        document.documentElement.style.setProperty(
          rawName,
          this.originalCssVariables[rawName]
        );
      });
    },
    getRootCssVariables() {
      if (utilities.isSSR()) {
        return [];
      }

      const cssVariables = [];

      for (const sheet of document.styleSheets) {
        // Check if the style sheet is from the same origin (to avoid cross-origin issues)
        if (sheet.href === null || sheet.href.startsWith(window.location.origin)) {
          // Iterate over all CSS rules in the style sheet
          for (const rule of sheet.cssRules) {
            // Check if the rule targets the root element
            if (rule.selectorText === ":root") {
              // Iterate over the CSS properties of the rule
              for (const property of rule.style) {
                // Check if the property is a CSS variable
                if (property.startsWith("--")) {
                  cssVariables.push(property);
                }
              }
            }
          }
        }
      }
      return cssVariables;
    },

  },
};
</script>

<style scoped lang="scss"></style>

<style lang="scss">
/*
:root {
  --c-core-lead-1: #d6d0b1;
  --c-core-lead-2: #979273;
  --c-core-lead: #5d5a45; //#5D5A45;
  --c-core-lead-4: #3b3b35;
  --c-core-lead-5: #2e2e29;
  --c-core-alt-2: #54de7d;
  --c-core-alt: #07a652;
  --c-core-alt-4: #068d46;
  --c-core-inverse: #333333;
  --c-core-bg-2: #ffffff;
  --c-core-bg: #f9f7e9;
  --c-core-bg-4: #f4f0d4;
  --c-core-bg-5: #d6d0b1;
  --c-text: #333333;
  --c-comp-lead: #8854d0;
  --c-comp-lead-2: #a55eea;
  --c-comp-lead-4: #7136c3;
  --c-comp-alt: #fa8231;
  --c-comp-alt-2: #fd9644;
  --c-comp-alt-4: #f86806;
  --c-gray-1: #f2f2f2;
  --c-gray-2: #d1d8e0;
  --c-gray: #a5b1c2;
  --c-gray-3: var(--c-gray);
  --c-gray-4: #778ca3;
  --c-gray-5: #393946;
  --c-success-1: #6dffb8;
  --c-success-2: #3ad985;
  --c-success: #07a652;
  --c-success-4: #068d46;
  --c-success-5: #00731f;
  --c-success-inverse: var(--c-bg);
  --c-warning: #ee8735;
  --c-warning-inverse: var(--c-bg);
  --c-danger: #eb3b5a;
  --c-danger-inverse: var(--c-bg);
  --c-error: var(--c-danger);
  --c-error-inverse: var(--c-danger-inverse);

  --c-lead: var(--c-core-lead);
  --c-lead-1: var(--c-core-lead-1);
  --c-lead-2: var(--c-core-lead-2);
  --c-lead-4: var(--c-core-lead-4);
  --c-lead-5: var(--c-core-lead-5);
  --c-alt: var(--c-core-alt);
  --c-alt-2: var(--c-core-alt-2);
  --c-alt-4: var(--c-core-alt-4);
  --c-inverse: var(--c-core-inverse);
  --c-bg-4: var(--c-core-bg-4);
  --c-bg-5: var(--c-core-bg-5);
  --c-bg: var(--c-core-bg);
  --c-bg-2: var(--c-core-bg-2);
  --c-bg-1: var(--c-core-bg-1);
}
*/
</style>
